<template lang='pug'>
.tableTop10-noArticleWrapper(style="position: relative")
  Loading(loader="dots" :active.sync="isLoading" :is-full-page="false")
  span.tableTop10-textNoArticle(v-if="!isLoading") {{ text }} 
  span.tableTop10-textNoArticle(v-else)
  .tableTop10-buttonsNoArticle(v-if="displayOption && !isLoading")
    button.tableTop10-buttonNoArticle(@click="filter('this-month')") 最近一個月
    button.tableTop10-buttonNoArticle(@click="filter('this-week')") 最近一週
</template>

<script>
import { getFilterRange } from '@/plugins/tool.js'
import Loading from 'vue-loading-overlay';
import $ from 'jquery'
export default {
  props: {
    filterType: String,
    text: String,
    displayOption: Boolean,
    isLoading: Boolean
  },
  components: {
    Loading
  },
  methods: {
    filter(filterType) {
      var days = getFilterRange(filterType)
      this.changeBtnColor(filterType)
      this.$emit('filter', days[0], days[1])
    },
    async changeBtnColor(filterType) {
      $("." + this.filterType).removeClass("title-buttonFilter--active")
      await this.$emit('changeType', filterType)
      $("." + filterType).addClass("title-buttonFilter--active")
    },
  }
}
</script>